import {
  PayloadDeleteSkillGroupType,
  PayloadSkillGroupType, PayloadSubSkillGroup, SkillGroup, SubSkillGroupManagement,
} from 'components/types/backOffice/company';
import { ResponseMutationSKillGroupType } from 'components/types/company';
import {
  PayloadDeleteCompLibraryType,
  PayloadListCompLibraryType, PayloadMoveCompLibraryType, PayloadMutationCompLibraryType, ResponseMutationCompLibType,
} from 'components/types/company/compLibraryType';
import { http } from 'helpers/http';

const URL = process.env.REACT_APP_API;
const URL_V2 = process.env.REACT_APP_API_V2;

export const apiSkillGroup = {
  skillGroupList: 'competency-skill-group/list',
  subSkillGroupList: 'competency-sub-skill-group/list',
  mutationSkillGroupManagement: 'competency-sub-skill-group/add-bulk',
};

export const apiCompetencyLibrary = {
  compLibraryList: 'competency/list',
  createCompLibrary: 'competency/create',
  updateCompLibrary: 'competency/update',
  deleteCompLibrary: 'competency/delete',
  moveCompetencyLib: 'competency/move',
};

export const skillGroupService = {
  getSkillGroup: async (): Promise<SkillGroup[]> => {
    const response = await http.post(`${URL}${apiSkillGroup.skillGroupList}`);

    return response.data?.data ?? response.data;
  },

  getSubSkillGroup: async (payload: PayloadSubSkillGroup): Promise<SubSkillGroupManagement[]> => {
    const response = await http.post(`${URL}${apiSkillGroup.subSkillGroupList}`, payload);

    return response.data?.data ?? response.data;
  },

  mutationSkillGroupManagement: async (payload: PayloadSkillGroupType): Promise<ResponseMutationSKillGroupType> => {
    const response = await http.post(`${URL}${apiSkillGroup.mutationSkillGroupManagement}`, payload);

    return response.data;
  },

  deleteSkillGroup: async (payload: PayloadDeleteSkillGroupType): Promise<ResponseMutationSKillGroupType> => {
    const response = await http.post(`${URL}${apiSkillGroup.mutationSkillGroupManagement}`, payload);

    return response.data;
  },
};

export const compLibraryService = {
  getCompLibrary: async (payload: PayloadListCompLibraryType): Promise<SkillGroup[]> => {
    const response = await http.post(`${URL}${apiCompetencyLibrary.compLibraryList}`, payload);

    return response.data?.data ?? response.data;
  },

  createCompLibrary: async (payload: PayloadMutationCompLibraryType): Promise<ResponseMutationCompLibType> => {
    const response = await http.post(`${URL}${apiCompetencyLibrary.createCompLibrary}`, payload);

    return response.data;
  },

  updateCompLibrary: async (payload: PayloadMutationCompLibraryType): Promise<ResponseMutationCompLibType> => {
    const response = await http.post(`${URL}${apiCompetencyLibrary.updateCompLibrary}`, payload);

    return response.data;
  },

  deleteCompLibrary: async (payload: PayloadDeleteCompLibraryType): Promise<ResponseMutationCompLibType> => {
    const response = await http.post(`${URL}${apiCompetencyLibrary.deleteCompLibrary}`, payload);

    return response.data;
  },

  moveCompLibrary: async (payload: PayloadMoveCompLibraryType): Promise<ResponseMutationCompLibType> => {
    const response = await http.post(`${URL}${apiCompetencyLibrary.moveCompetencyLib}`, payload);

    return response.data;
  },
};
